import React, { PureComponent } from 'react'
import {
  func, shape, bool, instanceOf,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import Link from '@active/react-ui/Link'
import { withI18n } from '@active/react-utils/i18n'

import Form from '../common/InjectedForm'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import I18nMessage from '../common/I18nMessage'
import CreateAccountDetail from './components/CreateAccount'
import CreatedAccount from './components/CreatedAccount'
import { FacebookCreateAccount, FacebookBindAccount } from '../common/Facebook'
import CoppaEmailInput from '../common/CoppaEmailInput'
import { omit, filterDate } from '../../shared/utils/commonUtils'
import CheckEmail from '../common/CheckEmail/CheckEmail'

import './Signup.scss'

class Signup extends PureComponent {
  static propTypes = {
    processes: shape({
      signIn: func.isRequired,
      signUp: func.isRequired,
    }).isRequired,
    actions: shape({
      signupSuccessCallback: func,
    }),
    services: shape({
      checkAccount: func.isRequired,
    }).isRequired,
    clientConfig: shape({
      disableSignInLink: bool,
    }).isRequired,
    FacebookBtn: shape({}).isRequired,
    configureTrack: func.isRequired,
    Header: func,
    dobField: shape({
      hidden: bool, value: instanceOf(Date), optional: bool, customerValidator: func,
    }),
  }

  static defaultProps = {
    Header: null,
    actions: {},
    dobField: {},
  }

  checkEmail

  constructor(props) {
    super(props)

    this.state = {
      coppaEmailResult: {},
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'CreateAccount',
      widget: 'create_account',
      pageType: 'create account',
    })
  }

  setSwitchConfig = newState => {
    this.setState({
      createAccountConfig: null,
      createdAccountSuccessConfig: null,
      facebookCreateAccountConfig: null,
      facebookBindAccountConfig: null,
      ...newState,
    })
  }

  checkEmailTrigger = checkEmail => {
    this.checkEmail = checkEmail
  }

  handleSubmit = values => {
    this.checkEmail(values.account, this.checkEmailCallback)
  }

  checkEmailCallback = ({ existAccount, newAccount, badDomain }) => {
    const { actions: { signupSuccessCallback } } = this.props
    if (existAccount) {
      this.goSignin({
        username: existAccount,
        existingAccount: true,
      })
    } else if (newAccount) {
      this.setSwitchConfig({
        createAccountConfig: {
          enableCoppaFlow: true,
          hideCollectingConsents: false,
          hasSubmitButton: true,
          hasSignInLink: true,
          hasSignupTitle: true,
          hasDefaultCreateHandle: true,
          fields: {
            email: newAccount,
          },
          onCreateAccountSuccess: createdAccountSuccessConfig => {
            if (signupSuccessCallback) {
              signupSuccessCallback(createdAccountSuccessConfig)
            } else {
              this.setSwitchConfig({ createdAccountSuccessConfig })
            }
          },
        },
      })
    } else if (badDomain) {
      this.setState({
        isShowEmailBadListTip: true,
      })
    }
  }

  goSignin = ({ username, existingAccount }) => {
    const { processes: { signIn, signUp: goBack } } = this.props

    signIn({
      goBack,
      username,
      existingAccount,
      sentEmailGoBack: goBack,
      goSignUp: '',
    })
  }

  handleFacebookCreateAccount = facebookCreateAccountConfig => this.setSwitchConfig({ facebookCreateAccountConfig })

  handleFacebookBindAccount = facebookBindAccountConfig => this.setSwitchConfig({ facebookBindAccountConfig })

  handleShowCoppaEmail = (showCoppaEmailInput, pendingKey) => {
    this.setState({
      coppaEmailResult: {
        showCoppaEmailInput,
        pendingKey,
      },
    })
  }

  render() {
    const {
      clientConfig: { disableSignInLink }, FacebookBtn,
      services, Header,
      // dobField for init Date
      dobField,
    } = this.props
    const {
      createAccountConfig,
      createdAccountSuccessConfig,
      facebookCreateAccountConfig,
      facebookBindAccountConfig,
      coppaEmailResult,
      isShowEmailBadListTip,
    } = this.state

    if (coppaEmailResult.showCoppaEmailInput) {
      return (
        <CoppaEmailInput Header={Header} {...coppaEmailResult} {...this.props} />
      )
    }

    if (createAccountConfig) {
      const initDob = filterDate(dobField.value) || new Date()
      return (
        <CreateAccountDetail
          {...createAccountConfig}
          {...omit(this.props, ['fields'])}
            // Extract init dob from Component to Widget
          dobField={({ ...dobField, value: initDob })}
            // USER-5726 Do not support amEighteen except CUISingup
          amEighteen={false}
        />
      )
    }
    if (createdAccountSuccessConfig) {
      return (
        <CreatedAccount {...this.props} {...createdAccountSuccessConfig} />
      )
    } if (facebookCreateAccountConfig) {
      return (
        <FacebookCreateAccount {...facebookCreateAccountConfig} {...this.props} />
      )
    } if (facebookBindAccountConfig) {
      return (
        <FacebookBindAccount
          handleReturn={() => this.setState({ facebookBindAccountConfig: null })}
          {...facebookBindAccountConfig}
          {...this.props}
        />
      )
    }

    return (
      <DefaultComponentLayout nameSpace="passport__signup" Header={Header}>
        <LayoutContent title message="passport.signup.title" />
        <LayoutContent main>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup name="account" required withoutLayout className="check-email-form-group" hideAsterisk>
              <FormLabel htmlFor="account"><I18nMessage id="passport.common.label.emailAddress" /></FormLabel>
              <FormField
                as={CheckEmail}
                changeAble
                services={services}
                checkEmailTrigger={this.checkEmailTrigger}
                requiredError="passport.error.validation.invalidEmail"
                invalidError="passport.error.validation.invalidEmail"
                enableDomainCheck
                tipContent="passport.common.text.typoTip.content.withRegist"
                isShowWarning={isShowEmailBadListTip}
              />
            </FormGroup>
            <Button submit type="super" className="passport__signup__button">
              <I18nMessage id="passport.common.btn.next" />
            </Button>
          </Form>
          {!disableSignInLink && (
          <div className="passport__form__subtitle passport__signup__signin">
            <I18nMessage id="passport.signup.notice.haveAccount" />
            <Link
              tabIndex={0}
              onClick={this.goSignin}
              className="passport__pl5"
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  this.goSignin({})
                }
              }}
            >
              <I18nMessage id="passport.common.btn.signIn" />
            </Link>
          </div>
          )}
          <FacebookBtn
            handleCreateAccount={this.handleFacebookCreateAccount}
            handleBindAccount={this.handleFacebookBindAccount}
            handleShowCoppaEmail={this.handleShowCoppaEmail}
            facebookText="passport.common.text.signUpWith"
            {...this.props}
          />
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default withI18n(Signup)
